export default __webpack_public_path__ + "static/media/bulb-16px.875cc6d0.svg";